import { createSharedPathnamesNavigation } from 'next-intl/navigation';
import { LOCALES } from 'src/envVariables';

const {
  Link: NextLink,
  useRouter,
  usePathname,
} = createSharedPathnamesNavigation({
  locales: LOCALES,
  localePrefix: 'as-needed',
});

export { NextLink, useRouter, usePathname };
